// Contact_Type__c is a restricted picklist, and which values are available
// depends on the record type. Salesforce's describe returns all 24 regardless,
// so it cannot answer "may I write this one" - a value valid for another record
// type is accepted by Postgres and then rejected by Salesforce on write-back
// with "bad value for restricted picklist field", leaving a row that never
// syncs and a dealer who saw a success message.
//
// The mapping below is derived from contacts that carry each record type and
// have an sfid, so every value listed is one Salesforce has demonstrably
// accepted. Record type ids are facts; the names are descriptive labels for
// readers, inferred from how each is used, not official Salesforce metadata
// (the recordtype object is not synced to Postgres).
import { RECORDTYPE_PERSON_CONTACT } from "./salesforceIds";

// Franchisee and business staff.
export const RECORDTYPE_BUSINESS_CONTACT = "01237000000bp9XAAQ";
export const RECORDTYPE_STSI_ONLY = "01237000000EzE0AAK";
export const RECORDTYPE_FOUNDATION_CONTACT = "012Ho000001CYuTIAW";

export const CONTACT_TYPES_BY_RECORD_TYPE = {
  // What ITFMA writes: the member and the people attached to their membership.
  [RECORDTYPE_PERSON_CONTACT]: [
    "Primary Contact",
    "Other",
    "Spouse Partner",
    "Job Contact",
    "Child",
    "Boat Co-owner",
    "Sibling",
    "Business Owner",
  ],
  [RECORDTYPE_BUSINESS_CONTACT]: [
    "Employee",
    "Captain",
    "Co-owner",
    "Owner",
    "Crew",
    "Office Manager",
    "Dispatcher",
    "General Manager",
    "Employee Prospect",
    "Marketing",
    "Event Guest",
    "Accounting",
  ],
  [RECORDTYPE_STSI_ONLY]: ["STSI - Only"],
  [RECORDTYPE_FOUNDATION_CONTACT]: [
    "Primary Contact",
    "Foundation",
    "Job Contact",
  ],
};

// In the picklist but never yet written under any record type, so there is no
// evidence for where they belong. Add them to a list above once Salesforce has
// accepted one, rather than guessing.
export const UNASSIGNED_CONTACT_TYPES = [
  "Kits\\Gift Cards Reseller",
  "Membership",
];

export function contactTypesFor(recordTypeId) {
  return CONTACT_TYPES_BY_RECORD_TYPE[recordTypeId] || [];
}
